"use client";

import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import { ColorModeProvider } from "./color-mode";
import { Toaster } from "./toaster";

export function Provider(props) {
	return (
		<ChakraProvider value={defaultSystem}>
			<ColorModeProvider {...props} forcedTheme="dark" />
			<Toaster />
		</ChakraProvider>
	);
}
